export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100% - 10px)',
        padding: "0px 15px 10px 15px",
        marginBottom: "10px"
    },
    cardContainer: {
        backgroundColor: "#FFFFFF",
        borderRadius: "20px",
        height: "100%",
        overflowY: "auto",
        padding: '20px'
    },
    appContainer: {
        padding: '15px',
        bgcolor: '#FFFFFF',
        borderRadius: '5px',
        border: '2px solid #DEDEDE',
        width: '300px'
    }

})